import { Reveal } from "@/components/Reveal";

const CHAPTERS = [
  {
    number: "01",
    title: "The Principle of Preservation",
    body: "Capital accumulation without tactical preservation is an illusion. Every strategy we engineer carries downside protection and tax efficiency at its core.",
  },
  {
    number: "02",
    title: "The Tax Advantage Blueprint",
    body: "Taxes are the single largest friction point to wealth growth. Our integrated tax preparation and planning eliminates leakage across every asset class.",
  },
  {
    number: "03",
    title: "Generational Impact",
    body: "True wealth is measured by what survives beyond us. We craft trusts, legacy funds, and business structures that empower the generations after you.",
  },
];

export const Manifesto = () => (
  <section
    id="philosophy"
    data-testid="manifesto-section"
    className="relative overflow-hidden bg-[#0F091A] py-28 lg:py-40"
  >
    <div
      className="absolute right-0 top-0 h-[26rem] w-[26rem] rounded-full bg-[#2E1065]/40 blur-[140px]"
      aria-hidden="true"
    />
    <div className="relative mx-auto max-w-7xl px-6 lg:px-10">
      <Reveal>
        <p className="eyebrow mb-6" data-testid="manifesto-eyebrow">The Manifesto</p>
        <h2 className="max-w-2xl font-display text-2xl font-semibold tracking-tight text-white sm:text-3xl lg:text-4xl">
          Three chapters govern
          <span className="text-gold-gradient"> every decision.</span>
        </h2>
      </Reveal>

      <div className="mt-20 space-y-0">
        {CHAPTERS.map((c, i) => (
          <Reveal key={c.number} delay={i * 0.08}>
            <div
              className="group grid grid-cols-1 gap-6 border-t border-gold/15 py-12 transition-colors duration-500 last:border-b hover:bg-royal/20 md:grid-cols-12 md:gap-10 md:px-6"
              data-testid={`manifesto-chapter-${c.number}`}
            >
              <div className="md:col-span-3">
                <span className="font-mono text-5xl font-light text-gold/30 transition-colors duration-500 group-hover:text-gold lg:text-6xl">
                  {c.number}
                </span>
              </div>
              <div className="md:col-span-4">
                <h3 className="font-display text-xl font-medium text-white sm:text-2xl">{c.title}</h3>
              </div>
              <div className="md:col-span-5">
                <p className="text-base leading-relaxed text-white/55">{c.body}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
